module.exports = __webpack_public_path__ + "img/CNlogo@2x.05fe5650.png";